/* eslint-disable no-mixed-operators */
import React, { useRef, useEffect, useState } from "react";
import { PortalContext } from "../../../context/Provider";
import { useContext } from "react";
import { hideModal, showModal } from "../../../context/Actions/modal/modal";
import { getDiaStrTurno } from "../../../../global/utils/diasTurno";
import { amOrPm } from "../../../../global/utils/amOrPm";
import CardTemplate from "../../Genericos/CardTemplate/CardTemplate";
import camelize from "../../../../global/utils/camelize";
import TurnoPresencialIcon from "../../../assets/images/generico/TurnoPresencialIcon";
import AlertIcon from "../../../assets/images/generico/AlertIcon";
import TurnoVideoConsultaIcon from "../../../assets/images/generico/TurnoVideoConsultaIcon";
import TildeOkAbonado from "../../../assets/images/generico/TildeOkAbonado";
import {
  cancelacionReset,
  wsGetValidaCancelacionQr,
  wsGetValidaCancelacionLabo,
} from "../../../context/Actions/turnos/cancelacion";
import { showToaster } from "../../../../global/context/action/toaster/toaster";
import CirculoRojo from "../../../assets/images/generico/CirculoRojo";
import Tooltip from "../../../../global/component/Genericos/Tooltip/Tooltip";
import CirculoInformacion from "../../../assets/images/generico/CirculoInformacion";
import "./CardTurno.css";
import DocumentoIcon from "../../../assets/images/generico/DocumentoIcon";
import PagarSeguro from "../../../assets/images/generico/PagarSeguro";
import {
  IdTurnoSolicitud,
  limpiarDatosMedico,
  limpiarListaMultimedia,
  limpiarMatriculaMedico,
  limpiarPlanKinesio,
  limpiarTipoTurno,
  resetIdTurnoSolicitud,
  wsGetPlanKinesio,
} from "../../../context/Actions/turnos/turnosPaciente";
import { mercadoPagoReset } from "../../../context/Actions/mercadoPago/mercadoPago";
import { IonSpinner } from "@ionic/react";
import { GlobalContext } from "../../../../global/context/Provider";

const CardTurno = ({ idPacienteFamiliar, recargoTurnos, turno }) => {
  const {
    modalDispatch,
    cancelacionState,
    cancelacionDispatch,
    motivoCancelacionState,
    turnosPacienteState,
    turnosPacienteDispatch,
    mercadoPagoDispatch,
    textosState,
    ordenEstudioState,
  } = useContext(PortalContext);

  // Toaster Global
  const { toasterDispatch } = useContext(GlobalContext);

  const [flgValidacion, setFlgValidacion] = useState(false);

  let config = localStorage.getItem("config");
  let mercadoPagoJson = JSON.parse(config).mercadoPago;

  const validaCancelacion = () => {
    if (turno.idProtocolo > 0) {
      showModalCancelarTurno();
      wsGetValidaCancelacionLabo(
        turno.idturno,
        idPacienteFamiliar
      )(cancelacionDispatch);
      setFlgValidacion(true);
    } else {
      showModalCancelarTurno();
      wsGetValidaCancelacionQr(turno.idturno)(cancelacionDispatch);
      setFlgValidacion(true);
    }
  };

  const trackButton = useRef();

  const showModalCancelarTurno = () => {
    if (!cancelacionState.cancelacion.error) {
      showModal(
        "Turnos/MensajeCancelarTurno/MensajeCancelarTurno",
        {
          titulo: "Cancelar turno",
          texto: `Desea cancelar ${
            turno.videoConsulta === true ? "la video consulta" : "su turno"
          } de ${turno.especialidad} del ${getDiaStrTurno(
            turno.fecha
          )} ${getDiaStrTurno(turno.fecha, true)} a las ${turno.hora} ${amOrPm(
            turno.hora
          )} ?`,
          items: turno.idProtocolo
            ? motivoCancelacionState.motivoCancelacion.laboratorio
            : motivoCancelacionState.motivoCancelacion.turnos,
          idturno: turno.idturno,
          idProtocolo: turno.idProtocolo,
          idTurnoSesion: turno.idTurnoSesion,
          idPacienteFamiliar: idPacienteFamiliar,
        },
        {},
        "centro",
        true
      )(modalDispatch);
    }
  };

  const dissmiss = (origen, estado, mensaje) => {
    if (origen === "mercadoPago") {
      if (estado) {
        showToaster(
          {
            texto: mensaje,
            tipo: "success",
          },
          "centroArriba"
        )(toasterDispatch);
      } else {
        showToaster(
          {
            texto: mensaje,
            tipo: "danger",
          },
          "centroArriba"
        )(toasterDispatch);
      }
      hideModal()(modalDispatch);
      mercadoPagoReset()(mercadoPagoDispatch);
      recargoTurnos();
    } else {
      hideModal()(modalDispatch);
      limpiarPlanKinesio()(turnosPacienteDispatch);
      limpiarDatosMedico()(turnosPacienteDispatch);
      limpiarListaMultimedia()(turnosPacienteDispatch);
      limpiarMatriculaMedico()(turnosPacienteDispatch);
      limpiarTipoTurno()(turnosPacienteDispatch);
      resetIdTurnoSolicitud()(turnosPacienteDispatch);
    }
    localStorage.setItem("alertaActive", "false");
  };

  const showModalAdjuntarOrden = (editOrden) => {
    if (editOrden) {
      showModal(
        "Genericos/EditarOrden/EditarOrden",
        {
          turno: turno,
          dissmiss: dissmiss,
        },
        {},
        "centro",
        true
      )(modalDispatch);
    } else {
      showModal(
        "Genericos/ModalSubirOrden/ModalSubirOrden",
        {
          turno: turno,
          dissmiss: dissmiss,
        },
        {},
        "centro",
        true
      )(modalDispatch);
    }
  };

  const showModalMatriculaMedico = (e) => {
    IdTurnoSolicitud(e)(turnosPacienteDispatch);
    showModal(
      "Turnos/MatriculaModal/MatriculaModal",
      {
        titulo: "Médico Solicitante",
        idturno: turno.idturno,
        idProtocolo: turno.idProtocolo,
        idPacienteFamiliar,
        medSolicitanteDto: turno.medSolicitanteDto,
        dissmiss: dissmiss,
      },
      {},
      "centro",
      true
    )(modalDispatch);
  };

  const showModalPlanKinesio = () => {
    wsGetPlanKinesio(
      turno.idTurnoSesion,
      idPacienteFamiliar
    )(turnosPacienteDispatch);
    showModal(
      "Turnos/PlanKinesio/PlanKinesio",
      {
        titulo: "Plan de Sesiones",
        fecha: turno.fecha,
        hora: turno.hora,
        especialidad: turno.especialidad,
        idTurnoSesion: turno.idTurnoSesion,
        idPacienteFamiliar: idPacienteFamiliar,
        dissmiss: dissmiss,
      },
      {},
      "centro",
      true
    )(modalDispatch);
  };

  const showModalAbonarTurno = () => {
    showModal(
      "Turnos/AbonaTurno/AbonaTurno",
      {
        idturno: turno.idturno,
        idProtocolo: turno.idProtocolo,
        monto: turno.monto,
        fecha: turno.fecha,
        hora: turno.hora,
        centro: turno.centro,
        especialidad: turno.especialidad,
        dismiss: dissmiss,
      },
      {},
      "centro",
      true
    )(modalDispatch);
  };

  const showModalPreparaciones = () => {
    showModal(
      "Turnos/Preparaciones/Preparaciones",
      {
        titulo: "Preparaciones",
        preparacion: turno.preparacion,
        autorizacion: turno.requiereAutorizacion,
        dissmiss: dissmiss,
      },
      {},
      "centro",
      true
    )(modalDispatch);
  };

  useEffect(() => {
    if (flgValidacion === true) {
      showModalCancelarTurno();
    } else if (cancelacionState.cancelacion.error) {
      showToaster(
        {
          texto: cancelacionState.cancelacion.validaCancelacion,
          tipo: "danger",
        },
        "centroArriba"
      )(toasterDispatch);
    }
    //eslint-disable-next-line
  }, [flgValidacion]);

  useEffect(() => {
    cancelacionReset()(cancelacionDispatch);
    //eslint-disable-next-line
  }, [cancelacionState.cancelacion.cancelaTurno]);

  useEffect(() => {
    if (cancelacionState.cancelacion.cancelaTurno) {
      limpiarPlanKinesio()(turnosPacienteDispatch);
    }
    //eslint-disable-next-line
  }, [cancelacionState.cancelacion.cancelaTurno]);

  useEffect(() => {
    if (turnosPacienteState.turnosPaciente.listaMultimedia) {
      limpiarListaMultimedia()(turnosPacienteDispatch);
    }
    //eslint-disable-next-line
  }, [turnosPacienteState.turnosPaciente.listaMultimedia]);

  return (
    <div ref={trackButton} className={`ptur-cardTurno`}>
      <CardTemplate
        classTemplateBox={`ptur-card-template-box`}
        classTittleBox="ptur-card-turno-titleBox"
        tituloCard={`${turno.especialidad}`}
        iconTituloCard={true}
        imgTittle={
          turno.videoConsulta === true ? (
            <TurnoVideoConsultaIcon />
          ) : (
            <TurnoPresencialIcon />
          )
        }
        bodyCard={
          <React.Fragment>
            <div className="ptur-card-cardTurno-body">
              <div className="ptur-card-cardTurno-body-datos">
                <span className="rb18b">
                  {getDiaStrTurno(turno.fecha)}{" "}
                  <span className="rb18l">
                    {getDiaStrTurno(turno.fecha, true)}
                  </span>
                </span>
                <span className="ptur-card-cardTurno-horario rb18b">
                  Horario:
                  <span className="rb18l">
                    {" "}
                    {turno.hora} {amOrPm(turno.hora)}
                  </span>
                </span>
                <div className="ptur-card-cardTurno-lista">
                  <ul>
                    {turno.medico && (
                      <li>
                        Especialista:{" "}
                        <span className="rb16b">{camelize(turno.medico)}</span>
                      </li>
                    )}

                    <li>
                      Tipo de Consulta:
                      {turno.videoConsulta === true ? (
                        <span className="rb16b"> Video Consulta</span>
                      ) : (
                        <span className="rb16b"> Presencial</span>
                      )}
                    </li>
                  </ul>
                </div>

                <span className="rb18b">
                  Centro:
                  <span className="rb18l"> {camelize(turno.centro)}</span>
                </span>
              </div>
              <div className="ptur-card-cardTurno-centro">
                <a
                  className="c-latex30 rb16l"
                  rel="noreferrer noopener"
                  target="_blank"
                  href={`https://maps.google.com/?q=${turno.coordenadaGps}`}
                >
                  {turno.ubicacion} - Buenos Aires
                </a>
                {!turno.videoConsulta ? (
                  <a
                    className="c-latex30 rb16l"
                    rel="noreferrer noopener"
                    target="_blank"
                    href={`https://www.google.com/maps/dir/?api=1&destination=${turno.coordenadaGps}&dir_action=navigate`}
                  >
                    Ir desde mi ubicación
                  </a>
                ) : (
                  ""
                )}
              </div>
              <div className="ptur-card-cardTurno-body-greyLine"></div>

              <>
                {turno.preparacion === null || turno.preparacion === "" ? (
                  ""
                ) : (
                  <>
                    {turno.requiereAutorizacion ? (
                      <div className="ptur-cardTurno-reqAutorizacion">
                        <Tooltip
                          descripcion={
                            textosState.textos.data.reqAutorizacion.descripcion
                          }
                          data={
                            <>
                              <AlertIcon color={"var(--color-danger)"} />
                              <span className="ptur-card-cardTurno-body-alertText rb14m c-danger">
                                Requiere Autorizacion
                              </span>
                            </>
                          }
                          customCss="ptur-card-cardturno-tooltip-reqAutorizacion"
                        />
                      </div>
                    ) : (
                      ""
                    )}
                    <div className="ptur-cardTurno-preparacion">
                      <button
                        className="ptur-card-cardTurno-btnPreparacion bgc-latex30 rb16m c-white"
                        onClick={() => showModalPreparaciones()}
                      >
                        <span>Volver a ver preparaciones</span>
                      </button>
                    </div>
                  </>
                )}
                {turno.flgSaldada && (
                  <div className="ptur-cardTurno-abonado">
                    {" "}
                    <TildeOkAbonado />
                    <span className="noSeleccionable rb18m c-broccoli">
                      Turno abonado
                    </span>
                  </div>
                )}
                {mercadoPagoJson === true
                  ? turno.monto > 0 &&
                    !turno.flgSaldada &&
                    ((turno.subeFotoOrden &&
                      turno.estadoOrden === "Validado") ||
                      !turno.subeFotoOrden) && (
                      <div className="ptur-cardTurno-abonar">
                        <button
                          className="ptur-card-cardTurno-ordenOpc-btnOrden bgc-danger rb16m c-white"
                          onClick={() => showModalAbonarTurno()}
                        >
                          <PagarSeguro />
                          <span>Abonar turno</span>
                        </button>
                      </div>
                    )
                  : ""}
                {turno.subeFotoOrden && !turno.tieneFotoOrden ? (
                  <div className="ptur-card-cardTurno-ordenOpc-box">
                    <button
                      className="ptur-card-cardTurno-ordenOpc-btnOrden bgc-danger rb16m c-white"
                      onClick={() => showModalAdjuntarOrden()}
                    >
                      {ordenEstudioState.ordenEstudio.loading ? (
                        <IonSpinner name="lines-small" />
                      ) : (
                        <>
                          <DocumentoIcon />
                          <span>Subir orden médica</span>
                        </>
                      )}
                    </button>
                  </div>
                ) : (
                  ""
                )}

                {turno.estadoOrden === "Pendiente" && turno.tieneFotoOrden ? (
                  //  &&
                  // multimedia.length > 0
                  <>
                    <div className="ptur-cardTurno-OrdenEnVerificacion">
                      <Tooltip
                        descripcion={
                          "Luego de la verificación, su estudio podría tener un costo"
                        }
                        data={
                          <>
                            <div className="ptur-cardTurno-OrdenEnVerificacion-iconTxt">
                              <CirculoInformacion />
                              <span className="underline noSeleccionable rb18m c-latex30">
                                Orden médica en verificación
                              </span>
                            </div>
                          </>
                        }
                        customCss="ptur-card-cardturno-tooltip-estadosPendiente"
                      />
                    </div>
                    <div className="ptur-card-cardTurno-subirOrdenAdicional">
                      <button
                        className="ptur-card-cardTurno-subirOrdenAdicional-Btn"
                        onClick={() => showModalAdjuntarOrden(true)}
                      >
                        <span className="ptur-card-cardTurno-vc-cancelarText rb16m">
                          Editar orden
                        </span>
                      </button>
                    </div>
                  </>
                ) : (
                  ""
                )}
                {turno.estadoOrden === "Rechazado" && (
                  <>
                    <div className="ptur-cardTurno-rechazado">
                      <Tooltip
                        descripcion={turno.motivoRechazoObservacion}
                        data={
                          <>
                            <div className="ptur-cardTurno-OrdenEnVerificacion-iconTxt-rechazada">
                              <CirculoRojo />
                              <span className="underline noSeleccionable rb18m c-danger">
                                Orden médica rechazada
                              </span>
                            </div>
                          </>
                        }
                        customCss="ptur-card-cardturno-tooltip-estados"
                      />
                    </div>
                    <div className="ptur-card-cardTurno-subirOrdenAdicional">
                      <button
                        className="ptur-card-cardTurno-subirOrdenAdicional-Btn"
                        onClick={() => showModalAdjuntarOrden(true)}
                      >
                        <span className="ptur-card-cardTurno-vc-cancelarText rb16m">
                          Editar orden
                        </span>
                      </button>
                    </div>
                  </>
                )}
                {turno.estadoOrden === "Validado" && (
                  <div className="ptur-cardTurno-abonado">
                    <TildeOkAbonado />
                    <span className="noSeleccionable rb18m c-broccoli">
                      Orden médica verificada
                    </span>
                  </div>
                )}
                {turno.medSolicitanteDto === null && turno.subeFotoOrden ? (
                  <div className="ptur-card-cardTurno-matricula-box">
                    <button
                      className="ptur-card-cardTurno-ordenOpc-btnOrden bgc-danger rb16m c-white"
                      onClick={() => showModalMatriculaMedico(turno.idturno)}
                    >
                      {ordenEstudioState.ordenEstudio.loading ? (
                        <IonSpinner name="lines-small" />
                      ) : (
                        <>
                          <DocumentoIcon />
                          <span>Ingresar Médico Solicitante</span>
                        </>
                      )}
                    </button>
                  </div>
                ) : (
                  ""
                )}
                {turno.medSolicitanteDto !== null && turno.subeFotoOrden ? (
                  <div className="ptur-cardTurno-abonado">
                    <TildeOkAbonado />
                    <span className="noSeleccionable rb18m c-broccoli">
                      Médico solicitante ingresado
                    </span>
                  </div>
                ) : (
                  ""
                )}
                {turno.idTurnoSesion > 0 ? (
                  <div className="ptur-card-cardTurno-ordenOpc-box">
                    {
                      <button
                        className="ptur-card-cardTurno-planKinesioBtn rb16m c-white"
                        onClick={() => showModalPlanKinesio()}
                      >
                        Ver plan de sesiones
                      </button>
                    }
                  </div>
                ) : (
                  ""
                )}

                <div className="ptur-card-cardTurno-vc-cancelarBox">
                  {turno.idTurnoSesion > 0 ? (
                    ""
                  ) : (
                    <button
                      className="ptur-card-cardTurno-vc-cancelarBtn"
                      onClick={validaCancelacion}
                    >
                      <span className="ptur-card-cardTurno-vc-cancelarText rb16m">
                        Cancelar turno
                      </span>
                    </button>
                  )}
                </div>
              </>
              <div className="ptur-card-cardturno-body-alertBox">
                <button className="ptur-card-cardturno-body-alertBtn">
                  {textosState.textos.data?.compromisoTurno?.descripcion ===
                    null ||
                  textosState.textos.data?.compromisoTurno?.descripcion ===
                    undefined ? (
                    ""
                  ) : (
                    <Tooltip
                      descripcion={
                        textosState.textos.data?.compromisoTurno?.descripcion
                      }
                      data={
                        <>
                          <AlertIcon />
                          <span className="ptur-card-cardTurno-body-alertText rb14m">
                            Tu compromiso reservando turnos
                          </span>
                        </>
                      }
                      customCss="ptur-card-cardturno-tooltip"
                    />
                  )}
                </button>
              </div>
            </div>
          </React.Fragment>
        }
      />
    </div>
  );
};

export default CardTurno;
